module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista zwrotów', 'ReturnList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "placeholder": _vm.$tr('', 'ReturnList'),
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'ReturnList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.search != '') ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'ReturnList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.search))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.filteredCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Pokaż', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.itemsPerPage,
      "default-label": _vm.defaultPerPage.name,
      "default-value": _vm.defaultPerPage.value
    },
    on: {
      "change": _vm.changePerPage
    }
  })], 1), _vm._v(" "), (_vm.storesDefaultFilter) ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Sklep', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.storesFilter,
      "default-label": _vm.storesDefaultFilter.name,
      "default-value": _vm.storesDefaultFilter.value
    },
    on: {
      "change": _vm.changeFilterByStore
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('radio', {
    attrs: {
      "items": _vm.dateRangesFilter
    },
    on: {
      "change": _vm.changeDateRange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Wyświetl:', 'ReturnList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.filterByStates,
      "default-label": _vm.defaultByStates.name,
      "default-value": _vm.defaultByStates.value
    },
    on: {
      "change": _vm.changeFilterByState
    }
  })], 1)], 1), _vm._v(" "), (!_vm.noContent) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.reference))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.firstname))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.store))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.data))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.amount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.notes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.status))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "reference"
    }, [_vm._v(_vm._s(item.reference))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "font-normal",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstname + ' ' + item.lastname, _vm.search))
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(typeof item.store_return !== 'undefined' ? item.store_return.name : ''))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.payment_info)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "total"
    }, [_vm._v(_vm._s(item.total_return) + " " + _vm._s(item.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.notes))]), _vm._v(" "), _c('td', {
      staticClass: "status",
      style: ({
        color: item.statusColor
      })
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Return',
          params: {
            reference: item.reference
          }
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-zoom",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : _c('div', {
    staticClass: "om-information"
  }, [_vm._v("\n    " + _vm._s(_vm.$tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'ReturnList')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div'), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce
    },
    on: {
      "change": _vm.updatePageContent
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c37285","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ReturnList.vue
// module id = 277
// module chunks = 1